import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import ChangePassword from './ChangePassword';
import Warehouse from './Warehouse';
import UpdateNotice from './UpdateNotice';

// HomeXpert คลังสินค้า & ผลิต — ระบบแยก (บัญชี Supabase ของคลังสินค้า ไม่ใช่บัญชีเดียวกับ Operations Portal)
// ตั้งค่าในไฟล์ .env: REACT_APP_SUPABASE_URL และ REACT_APP_SUPABASE_PUBLISHABLE_KEY ของโปรเจกต์คลังสินค้า
const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;
const supabase = url && publishableKey ? createClient(url, publishableKey) : null;

const TEAL = '#1a73e8';
const input = { width: '100%', padding: 12, border: '1px solid #cbd5e1', borderRadius: 8, boxSizing: 'border-box' };
const button = { padding: '10px 15px', border: 0, borderRadius: 8, background: TEAL, color: '#fff', cursor: 'pointer', font: 'inherit' };
const card = { background: '#fff', border: '1px solid #e2e8f2', borderRadius: 14, padding: 22 };
const page = { minHeight: '100vh', background: '#f4f8fd', display: 'grid', placeItems: 'center', fontFamily: '"Noto Sans Thai", "Segoe UI", Tahoma, sans-serif' };
const startsInRecovery = () => { try { return /(^|[#&?])type=recovery(&|$)/.test(window.location.hash + '&' + window.location.search.replace(/^\?/, '')); } catch { return false; } };

export default function App() {
  const [session, setSession] = useState(null), [checking, setChecking] = useState(Boolean(supabase));
  const [email, setEmail] = useState(''), [password, setPassword] = useState(''), [showPw, setShowPw] = useState(false);
  const [recovery, setRecovery] = useState(startsInRecovery);  // ลืมรหัสผ่าน → ให้ Admin รีเซ็ต (W21)
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const [newPw, setNewPw] = useState(''), [newPw2, setNewPw2] = useState('');
  const [me, setMe] = useState(undefined), [changePw, setChangePw] = useState(false), [mustPw, setMustPw] = useState(false);

  useEffect(() => {
    if (!supabase) return;
    let alive = true;
    supabase.auth.getSession().then(({ data }) => { if (alive) { setSession(data?.session ?? null); setChecking(false); } });
    const { data: l } = supabase.auth.onAuthStateChange((event, s) => { if (!alive) return; if (event === 'PASSWORD_RECOVERY') setRecovery(true); setSession(s); });
    return () => { alive = false; l.subscription.unsubscribe(); };
  }, []);
  // สิทธิ์ของผู้ใช้ (null = ล็อกอินได้ แต่ผู้ดูแลยังไม่ได้ให้สิทธิ์)
  useEffect(() => {
    if (!supabase || !session) { setMe(undefined); return; }
    let alive = true;
    supabase.schema('whcore').rpc('my_access').then(({ data, error: e }) => { if (alive) setMe(e ? { error: e.message } : ((data || [])[0] || null)); });
    // Admin รีเซ็ตรหัสให้ → ต้องตั้งรหัสใหม่ก่อนใช้งาน (ถ้ายังไม่รัน W21 ถือว่าไม่ต้อง)
    supabase.schema('whcore').rpc('my_must_change_pw').then(({ data, error: e }) => { if (alive) setMustPw(!e && data === true); });
    return () => { alive = false; };
  }, [session]);

  async function signIn(e) {
    e.preventDefault(); setBusy(true); setError('');
    const { error: err } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    setPassword(''); setBusy(false);
    if (err) setError('เข้าสู่ระบบไม่สำเร็จ โปรดตรวจสอบอีเมล/รหัสผ่าน หรือสอบถามผู้ดูแลระบบ');
  }
  async function saveNewPassword(e) {
    e.preventDefault(); setError('');
    if (newPw.length < 8) { setError('รหัสผ่านใหม่ต้องยาวอย่างน้อย 8 ตัวอักษร'); return; }
    if (newPw !== newPw2) { setError('รหัสผ่านทั้งสองช่องไม่ตรงกัน'); return; }
    setBusy(true); const { error: err } = await supabase.auth.updateUser({ password: newPw }); setBusy(false);
    if (err) { setError('ตั้งรหัสผ่านไม่สำเร็จ: ' + (err.message || 'ลิงก์อาจหมดอายุ')); return; }
    setNewPw(''); setNewPw2(''); try { window.history.replaceState(null, '', window.location.pathname); } catch { /* ไม่เป็นไร */ }
    setRecovery(false);
  }

  if (!supabase) return <div style={page}><div style={{ ...card, maxWidth: 640 }}><h2>ยังไม่ได้ตั้งค่า Supabase</h2>
    <p>สร้างไฟล์ <b>.env</b> ในโฟลเดอร์ homexpert-warehouse แล้วใส่ REACT_APP_SUPABASE_URL และ REACT_APP_SUPABASE_PUBLISHABLE_KEY ของโปรเจกต์คลังสินค้า จากนั้นปิดแล้วเปิดโปรแกรมทดสอบใหม่</p></div></div>;
  if (checking) return <p style={{ padding: 32, fontFamily: 'sans-serif' }}>กำลังตรวจสอบสถานะเข้าสู่ระบบ…</p>;

  if (recovery && session) return <div style={page}>
    <form onSubmit={saveNewPassword} style={{ ...card, width: 'min(400px, 90vw)' }}>
      <h2 style={{ color: TEAL, marginBottom: 3 }}>ตั้งรหัสผ่านใหม่</h2><p style={{ color: '#64748b', marginTop: 0 }}>บัญชี {session.user.email}</p>
      <label htmlFor="np">รหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)</label>
      <input id="np" type={showPw ? 'text' : 'password'} required autoComplete="new-password" value={newPw} onChange={(e) => setNewPw(e.target.value)} style={{ ...input, margin: '6px 0 14px' }} />
      <label htmlFor="np2">พิมพ์รหัสผ่านใหม่อีกครั้ง</label>
      <input id="np2" type={showPw ? 'text' : 'password'} required autoComplete="new-password" value={newPw2} onChange={(e) => setNewPw2(e.target.value)} style={{ ...input, margin: '6px 0 10px' }} />
      <label style={{ display: 'flex', gap: 7, alignItems: 'center', fontSize: 13, marginBottom: 14 }}><input type="checkbox" checked={showPw} onChange={(e) => setShowPw(e.target.checked)} /> แสดงรหัสผ่าน</label>
      {error && <p role="alert" style={{ color: '#b91c1c' }}>{error}</p>}
      <button style={{ ...button, width: '100%' }} disabled={busy} type="submit">{busy ? 'กำลังบันทึก…' : 'บันทึกรหัสผ่านใหม่'}</button>
    </form></div>;

  if (!session) return <div style={page}>
    <form onSubmit={signIn} style={{ ...card, width: 'min(400px, 90vw)', boxShadow: '0 10px 30px #1e293b16' }}>
      <div style={{ fontSize: 34 }} aria-hidden="true">🏠</div>
      <h2 style={{ color: '#1f2a44', margin: '4px 0 3px' }}>HomeXpert <span style={{ color: TEAL }}>คลังสินค้า & ผลิต</span></h2>
      <p style={{ color: '#64748b', marginTop: 0 }}>เข้าสู่ระบบ</p>
      <label htmlFor="email">อีเมลพนักงาน</label>
      <input id="email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} style={{ ...input, margin: '6px 0 14px' }} />
      <>
        <label htmlFor="password">รหัสผ่าน</label>
        <div style={{ position: 'relative', margin: '6px 0 10px' }}>
          <input id="password" type={showPw ? 'text' : 'password'} required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ ...input, paddingRight: 78 }} />
          <button type="button" onClick={() => setShowPw((v) => !v)} aria-pressed={showPw} style={{ position: 'absolute', right: 6, top: 6, bottom: 6, padding: '0 10px', border: '1px solid #cbd5e1', borderRadius: 6, background: '#f1f5f9', color: '#334155', cursor: 'pointer', fontSize: 12 }}>{showPw ? '🙈 ซ่อน' : '👁 แสดง'}</button>
        </div></>
      {error && <p role="alert" style={{ color: '#b91c1c' }}>{error}</p>}
      <button style={{ ...button, width: '100%', marginTop: 6, opacity: busy ? 0.6 : 1 }} disabled={busy} type="submit">{busy ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบ'}</button>
      <p style={{ textAlign: 'center', margin: '14px 0 2px', fontSize: 13.5, color: '#64748b' }}>ลืมรหัสผ่าน? <b style={{ color: '#334155' }}>ติดต่อผู้ดูแลระบบ (Admin)</b><br />เพื่อรีเซ็ตรหัสผ่าน — ระบบจะส่งรหัสชั่วคราวไปที่อีเมลของคุณ</p>
    </form></div>;

  if (me === undefined || me?.error || !me) return <div style={page}><section style={{ ...card, maxWidth: 560 }}>
    {me === undefined ? <p role="status">กำลังตรวจสอบสิทธิ์…</p>
      : me?.error ? <><h2>อ่านสิทธิ์ไม่สำเร็จ</h2><p>{me.error}</p><p style={{ fontSize: 13 }}>ถ้าเพิ่งตั้งระบบใหม่ ต้องรันไฟล์ W01_setup.sql ใน Supabase ก่อน</p></>
      : <><h2>ยังไม่มีสิทธิ์เข้าใช้งาน</h2><p>บัญชี {session.user.email} ยังไม่ได้รับสิทธิ์ กรุณาแจ้งผู้ดูแลระบบให้เพิ่มที่เมนู ผู้ใช้งาน / สิทธิ์</p></>}
    {me !== undefined && <button onClick={() => supabase.auth.signOut()} style={button}>ออกจากระบบ</button>}</section></div>;

  return <>
    <Warehouse supabase={supabase} me={me} email={session.user.email} onChangePw={() => setChangePw(true)} onSignOut={() => supabase.auth.signOut()} />
    {changePw && !mustPw && <ChangePassword supabase={supabase} email={session.user.email} onClose={() => setChangePw(false)} />}
    {mustPw && <ChangePassword forced supabase={supabase} email={session.user.email} onClose={() => supabase.auth.signOut()} onDone={() => setMustPw(false)} />}
    <UpdateNotice />
  </>;
}
